module.exports = __webpack_public_path__ + "img/29.c079e383.png";